/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * el alumno puede subir pdf, doc i docx [P_A_22]
 * @export
 * @interface CandidateDocument
 */
export interface CandidateDocument {
    /**
     * 
     * @type {number}
     * @memberof CandidateDocument
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateDocument
     */
    fileName?: string;
}

export function CandidateDocumentFromJSON(json: any): CandidateDocument {
    return CandidateDocumentFromJSONTyped(json, false);
}

export function CandidateDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fileName': !exists(json, 'file_name') ? undefined : json['file_name'],
    };
}

export function CandidateDocumentToJSON(value?: CandidateDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.fileName,
    };
}


